import React, { useState, useEffect, useContext } from "react";
import "../styles/style.css"
import { api_domain } from "../config"
import Menu from "../components/navbar.js";
import { AuthContext } from "../components/AuthContext";

export function Contact() {
  const [summary, setSummary] = useState(null);
  const { basicHttpAuthString } = useContext(AuthContext);

  useEffect(() => {
    fetch(`${api_domain}/report/overall`, {
      headers: {
        Authorization: `${basicHttpAuthString}`
      }
    })
      .then((response) => response.json())
      .then((data) => setSummary(data));
  }, [])

  return (

    <div className="container">
    <Menu/>
    {/*<script>{menuFunction()}</script>*/}
    <div className="tools">
        <div className="titleMain">Contact us</div>
        <div className="txt">
        <p>Do you have questions, comments, requests for data, ideas for collaboration? Please contact us at <b>ad-archive@cs.washington.edu</b>.</p>
        </div>
   </div>
   </div>
  );
}
